


























































































































































/* eslint-disable @typescript-eslint/camelcase */
import {Component, Mixins, Ref, Vue} from "vue-property-decorator";
import EmployeeMixin from "@/mixins/employee";
import {Api} from "shared/api";
import {faHome} from "@fortawesome/free-solid-svg-icons";
import OpenerMixin from "@/mixins/opener";
import {GenerateContactLensRequest} from "shared/api/requests/generateFileRequest";
import {DateTime} from "luxon";
import CustomDropdown, {CustomDropdownValue} from "@/components/CustomDropdown.vue";

@Component({
    components: {CustomDropdown}
})
export default class Spectacle extends Mixins(EmployeeMixin, OpenerMixin) {
    constructor() {
        super();
        this.resetForm();
        for (let i = 20; i >= -20; i -= 0.25) {
            if (i === 0) {
                this.sphereSizes.push("Plano");
                this.sphereSizes.push("");
            } else if (i > 0) {
                this.sphereSizes.push("+" + i.toFixed(2));
            } else {
                this.sphereSizes.push(i.toFixed(2));
            }
        }
        for (let i = -0.25; i >= -8; i -= 0.25) {
            this.cylinderSizes.push(i.toFixed(2));
        }
    }

    public customDropdowns = {
        OD_Add: new CustomDropdownValue<string>(""),
        OS_Add: new CustomDropdownValue<string>(""),
    };

    public icons = {
        faHome,
    }

    public manufacturers = [
        "Cooper vision",
        "Alcon",
        "Johnson & Johnson",
        "Bausch & Lomb",
        "Art Optical",
    ]

    public manuallySetExpiration = false;
    public sphereSizes: string[] = [];
    public cylinderSizes: string[] = [""];
    public addSizes: string[] = ["Low", "Medium", "High"];
    public form!: GenerateContactLensRequest;

    @Ref("htmlForm") htmlForm!: HTMLFormElement;
    @Ref("osMan") osMan!: unknown;

    private async mounted() {
        if (!await this.authorized()) {
            await this.$router.push({name: "Login"});
        }
    }

    private async onExamDateSet() {
        if (!this.manuallySetExpiration) {
            this.setExpirationDate();
        }
    }

    private setExpirationDate() {
        this.form.Expiration_Date = DateTime.fromISO(this.form.Exam_Date).plus({years: 1}).toISODate();
        this.$forceUpdate();
    }

    private setOSManufacturer(v: string) {
        this.form.OS_Manufacturer = v;
        ((this.osMan as Vue).$refs.input as HTMLInputElement).value = v;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this.osMan as any).handleInput(v);
        this.$forceUpdate();
    }

    async submit() {
        const win = this.createWindow();
        this.form.OD_Add = this.customDropdowns.OD_Add.value || "";
        this.form.OS_Add = this.customDropdowns.OS_Add.value || "";
        const result = await Api.generate.ContactLens.Post(this.form);
        if (result.success) {
            win.setUrl(Api.generate.File._uri + `?file=${result.result.file}`);
        } else {
            alert("Something went wrong. Please try again. If the problem persist, contact Support at (248) 545-0800");
        }
    }

    private resetForm() {
        this.form = {
            company: "",
            Patient_Name: "",
            Date_of_Birth: "",
            Exam_Date: DateTime.local().toISODate(),
            Expiration_Date: "",
            OD_Manufacturer: "",
            OD_Brand: "",
            OS_Manufacturer: "",
            OS_Brand: "",
            OD_BC: "",
            OS_BC: "",
            OS_Sph: "",
            OD_Sph: "",
            OD_Cyl: "",
            OS_Cyl: "",
            OD_Axis: "",
            OS_Axis: "",
            OD_Diam: "",
            OS_Diam: "",
            OS_Add: "",
            OD_Add: "",
            OD_Color: "",
            OS_Color: ""
        };
        this.setExpirationDate();
    }
}
